import React from 'react';
import BigNumber from 'bignumber.js';
import { faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PoolCardHarvestSection from './components/PoolCardHarvestSection';
import PoolCardStakeSection from './components/PoolCardStakeSection';
import PoolCardFooterSection from './components/PoolCardFooterSection';
import PoolCardNftSection from './components/PoolCardNftSection';
// import PoolCardPredictionGameSection from './components/PoolCardPredictionGameSection';

import './PoolCard.css';

const ZERO = new BigNumber(0);

const PoolCard = ({ poolData, currentBlock }) => {
  const poolImageSrc = () => `/images/farms/${poolData.name}.png`.replace(/\s/g, '-').toLowerCase();

  const startBlock = new BigNumber(poolData.startBlock);
  const endBlock = new BigNumber(poolData.endBlock);
  const startBlockDiff = startBlock.gt(currentBlock) ? startBlock.minus(currentBlock) : ZERO;
  const endBlockDiff = endBlock.gt(currentBlock) ? endBlock.minus(currentBlock) : ZERO;

  return (
    <div className="column is-half-tablet is-one-third-desktop">
      <div className={ `box is-relative ${poolData.canWithdraw ? '' : 'gradient-border'}` }>
        <div className="level is-mobile">
          <div className="level-left">
            <div className="level-item">
              <figure className="image is-64x64">
                <img src={ poolImageSrc() } alt={ poolData.name } />
              </figure>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <div className="is-flex is-flex-direction-column is-align-items-flex-end">
                <h5 className="is-size-5 has-text-weight-semibold">{ poolData.name }</h5>
                <span className="tag is-rounded is-primary">
                  { poolData.category }
                </span>
              </div>
            </div>
          </div>
        </div>
        {poolData.userHasNFT ? <PoolCardNftSection poolData={ poolData } /> : null}
        <div className="level is-mobile mb-1">
          <div className="level-left">
            <div className="level-item">
              APR
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <h6 className="is-size-6 has-text-weight-semibold">
                { new BigNumber(poolData.apr).times(100).toFormat(2) }%
              </h6>
            </div>
          </div>
        </div>
        <div className="level is-mobile mb-1">
          <div className="level-left">
            <div className="level-item">
              Earn
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <h6 className="is-size-6 has-text-weight-semibold">{ poolData.rewardToken.toUpperCase() }</h6>
            </div>
          </div>
        </div>
        <PoolCardHarvestSection poolData={ poolData } />
        {/* <PoolCardPredictionGameSection poolData={ poolData } /> */}
        <PoolCardStakeSection poolData={ poolData } />
        {startBlockDiff.gt(0) ? (
          <div className="level is-mobile mb-1">
            <div className="level-left">
              <div className="level-item">
                <a href={ `${process.env.REACT_APP_EXPLORER}/block/countdown/${startBlock.toString()}` } target="_blank" rel="noreferrer" className="has-text-dark is-underlined">
                  <span className="icon-text">
                    <span className="icon">
                      <FontAwesomeIcon icon={ faStopwatch } />
                    </span>
                    Starts at:
                  </span>
                </a>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <h6 className="is-size-6 has-text-weight-semibold">{ startBlockDiff.toFormat() } blocks</h6>
              </div>
            </div>
          </div>
        ) : (
          <div className="level is-mobile mb-1">
            <div className="level-left">
              <div className="level-item">
                <a href={ `${process.env.REACT_APP_EXPLORER}/block/countdown/${endBlock.toString()}` } target="_blank" rel="noreferrer" className="has-text-dark is-underlined">
                  <span className="icon-text">
                    <span className="icon">
                      <FontAwesomeIcon icon={ faStopwatch } />
                    </span>
                    Ends at:
                  </span>
                </a>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <h6 className="is-size-6 has-text-weight-semibold">{ endBlockDiff.toFormat() } blocks</h6>
              </div>
            </div>
          </div>
        )}
        <div className="level is-mobile mb-1">
          <div className="level-left">
            <div className="level-item">
              Pool Reward
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <div className="is-flex is-flex-direction-column is-align-items-flex-end">
                <h6 className="is-size-6 has-text-weight-semibold">{ new BigNumber(poolData.poolReward).toFormat(2) }</h6>
                <h6 className="is-size-6 has-text-weight-semibold">~$ { new BigNumber(poolData.poolRewardStable).toFormat(2) }</h6>
              </div>
            </div>
          </div>
        </div>
        <div className="level is-mobile">
          <div className="level-left">
            <div className="level-item">
              Experience Reward
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <h6 className="is-size-6 has-text-weight-semibold">{ new BigNumber(poolData.experienceReward).toFormat(0) } pts</h6>
            </div>
          </div>
        </div>
        <hr />
        <PoolCardFooterSection poolData={ poolData } />
      </div>
    </div>
  );
}

export default PoolCard;
